import type { CSSProperties, FC, ReactNode } from 'react'

import { useInView } from '@/hooks/use-in-view'

type RevealTag = 'div' | 'li' | 'article' | 'section' | 'p' | 'figure'

interface RevealProps {
    as?: RevealTag
    children: ReactNode
    className?: string
    variant?: 'up' | 'left' | 'right' | 'pop' | 'fade'
    delay?: number
    id?: string
}

/**
 * Steps its children into view the first time they scroll on screen.
 * The motion lives in globals.css ([data-reveal]) and is skipped for reduced-motion visitors.
 */
export const Reveal: FC<RevealProps> = ({
    as: Tag = 'div',
    children,
    className,
    variant = 'up',
    delay = 0,
    id
}): ReactNode => {
    const [ref, inView] = useInView()

    return (
        <Tag
            ref={ref}
            id={id}
            data-reveal={variant}
            data-shown={inView ? 'true' : 'false'}
            style={{ '--reveal-delay': `${delay}ms` } as CSSProperties}
            className={className}
        >
            {children}
        </Tag>
    )
}
